/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_ReceivedInputs */

const en_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders Received`)
};

const es_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos recibidos`)
};

const fr_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes reçues`)
};

const de_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhaltene Bestellungen`)
};

const ja_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受注した注文`)
};

const zh_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已接订单`)
};

const ar_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلبات المستلمة`)
};

const id_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan Diterima`)
};

const it_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordini Ricevuti`)
};

const ru_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получено заказов`)
};

const pt_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos Recebidos`)
};

const ko_orders_received = /** @type {(inputs: Orders_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받은 주문`)
};

/**
* | output |
* | --- |
* | "Orders Received" |
*
* @param {Orders_ReceivedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const orders_received = /** @type {((inputs?: Orders_ReceivedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_ReceivedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_received(inputs)
	if (locale === "es") return es_orders_received(inputs)
	if (locale === "fr") return fr_orders_received(inputs)
	if (locale === "de") return de_orders_received(inputs)
	if (locale === "ja") return ja_orders_received(inputs)
	if (locale === "zh") return zh_orders_received(inputs)
	if (locale === "ar") return ar_orders_received(inputs)
	if (locale === "id") return id_orders_received(inputs)
	if (locale === "it") return it_orders_received(inputs)
	if (locale === "ru") return ru_orders_received(inputs)
	if (locale === "pt") return pt_orders_received(inputs)
	return ko_orders_received(inputs)
});